const accordion = document.getElementsByClassName('support-faq-accordion');
const formElement = document.querySelector('[data-search-support]');
const formResults = document.querySelector('[data-search-support-results]');
const supportSidebar = document.querySelector('[data-support-sidebar]');
const supportContent = document.querySelector('.support-content-bottom');

export function showSupportSuggestions(json) {
    let formResultsHtml = formResults.innerHTML;

    if (Object.keys(json).length > 0) {
        formResultsHtml += '<ul>';

        json.forEach((suggestion) => {
            formResultsHtml += `<li><strong>${suggestion.question}</strong><br />${suggestion.answer}<strong></strong><br /><ul class="search-support-suggestions-crosslinks">`;
            if (suggestion.link_article_1) {
                formResultsHtml += `<li><a href="${suggestion.link_article_1}">${suggestion.link_article_one.title}</a></li>`;
            }
            if (suggestion.link_article_2) {
                formResultsHtml += `<li><a href="${suggestion.link_article_2}">${suggestion.link_article_two.title}</a></li>`;
            }
            if (suggestion.link_article_3) {
                formResultsHtml += `<li><a href="${suggestion.link_article_3}">${suggestion.link_article_three.title}</a></li>`;
            }
            formResultsHtml += '</ul></li>';
        });

        formResultsHtml += '</ul>';

        formResults.innerHTML = formResultsHtml;
        formResults.setAttribute('aria-hidden', 'false');
    } else {
        resetForm();
    }
}

export function resetForm() {
    formResults.setAttribute('aria-hidden', 'true');
    formResults.innerHTML = '';
}

export function getSupportSuggestions(formSearchInput) {
    const Request = new XMLHttpRequest();
    Request.open('GET', `${formElement.getAttribute('data-change-route')}/${formSearchInput.value}`);
    Request.setRequestHeader('Accept', 'application/json');
    formElement.setAttribute('aria-busy', 'true');

    resetForm();

    if (formSearchInput.value !== '') {
        let called = false;
        Request.onreadystatechange = () => {
            if (Request.readyState === XMLHttpRequest.DONE && !called) {
                if (Request.status === 0 || (Request.status >= 200 && Request.status < 400)) {
                    showSupportSuggestions(JSON.parse(Request.responseText));
                } else if ([500, 404, 422].includes(Request.status)) {
                    showSupportSuggestions([]);
                }

                called = true;
                formElement.setAttribute('aria-busy', 'false');
            }
        };
    }

    Request.send(new FormData(formElement));
}

export default function initSupport() {
    // Faq accordions
    let i;
    for (i = 0; i < accordion.length; i++) {
        accordion[i].addEventListener('click', function () {
            this.classList.toggle('active');
            const panel = this.nextElementSibling;

            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = `${panel.scrollHeight}px`;
            }
        });
    }

    // Eventhandler for search
    if (formElement) {
        const formSearchInput = formElement.querySelector('input[type="search"]');
        let timer;

        formSearchInput.addEventListener('keyup', (e) => {
            if (e.keyCode === 40) {
                formResults.firstElementChild.focus();
                document.addEventListener('keydown', (e) => {
                    const nextFocus = document.activeElement.nextElementSibling;
                    const prevFocus = document.activeElement.previousElementSibling;
                    const inputKeyCode = e.keyCode;

                    if (inputKeyCode === 40) {
                        e.preventDefault();
                        if (nextFocus) {
                            nextFocus.focus();
                        }
                    } else if (inputKeyCode === 38) {
                        e.preventDefault();
                        if (prevFocus) {
                            prevFocus.focus();
                        }
                    } else {
                        formSearchInput.focus();
                    }
                });
            } else {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    getSupportSuggestions(formSearchInput);
                }, 200);
            }
        });
    }

    // Sidebar has to scroll with content on desktop
    window.addEventListener('scroll', () => {
        if (window.innerWidth > 768 && supportContent) {
            if (window.scrollY > (supportContent.offsetTop - 600)) {
                supportSidebar.style.bottom = '0';
                supportSidebar.style.top = 'auto';
            } else {
                supportSidebar.style.bottom = 'auto';
                const extraTopOffset = (window.scrollY > 250) ? 100 : 0;
                supportSidebar.style.top = `${window.scrollY + extraTopOffset}px`;
            }
        }
    });

    // Articles have to scroll into view on mobile when a theme filter is set
    // A theme filter is set when the make a choice message not exists
    if (!document.querySelector('.support-make-a-choice-message') && document.querySelector('.support-articles') && window.innerWidth < 768) {
        const supportArticles = document.querySelector('.support-articles');
        supportArticles.scrollIntoView();
    }
}
